import { computed } from 'vue'
import { useFeature } from '/@/core/feature'
import { device } from '/@/utils/responsive'

export function useMobileGuard() {
  const mobileVizFeature = useFeature('mobile-viz')

  // mimics the old behavior to determine if viz is enabled
  // touch would be net-new, and we can use it to allow mobile viz UX
  const featureAllowed = computed(
    () => device.isAtLeastSm || mobileVizFeature.enabled,
  )

  return { featureAllowed }
}
